import React, {memo, useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useInput, useNotification} from '~/hooks';
import {Col, UiImage, UiText, UiQuestionnaireLayout, UiBox, UiSimpleGrid, UiButton} from '~/components/elements';
import {RootState} from '~/redux/root-reducer';
import {STI_TESTING_KEYS} from '~/constants/medical-questionnaires';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {Option} from '~/redux/questionnaires/types';
import {spacing} from '~/utils/theme/spacing';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';

const Questionnaire4Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[STI_TESTING_KEYS.WHY_THINKING_STI_TEST]?.data,
  );

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === STI_TESTING_KEYS.WHY_THINKING_STI_TEST);

  let medicalOptions: Option[] = [];
  if (questionnaire?.options?.length) {
    medicalOptions = questionnaire?.options?.filter(i => i?.value !== 'NONE');
  }

  const {inputs, setInputs, validation} = useInput({
    selectedOption: currentAnswer?.selectedOption || '',
  });

  const onClickOption = (answer: {value: string | number; label: string}) => {
    const {value} = answer;
    setInputs({selectedOption: value});
  };

  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: STI_TESTING_KEYS.WHY_THINKING_STI_TEST,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    if (inputs.selectedOption === 'NONE_OF_THE_ABOVE') {
      dispatch(setNextQuestionnaire({value: STI_TESTING_KEYS.MORE_INFORMATION}));
    } else {
      dispatch(setNextQuestionnaire({value: STI_TESTING_KEYS.SAMPLE_COLLECTION_LOCATION}));
    }
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      disableNext={!inputs.selectedOption}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.medium} />
        <UiText fontSize="xl" fontWeight="bold" mt={spacing.large}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiBox mt={spacing.small} w="100%">
          <UiSimpleGrid columns={{base: 1, lg: 2}} spacing={5}>
            {medicalOptions?.map(value => (
              <ScrollToBottomButton
                key={`${value.label}-${value.value}`}
                title={value.label}
                variant={inputs.selectedOption === value.value ? 'solid' : 'toggle'}
                onClick={() => onClickOption(value)}
              />
            ))}
          </UiSimpleGrid>
        </UiBox>
        <UiText fontSize="sm" mt={spacing.small}>
          Select the option that best applies to you
        </UiText>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire4Screen;
